import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { useNativeEvents } from 'hooks/useNativeEvents';
import { useSelector } from 'react-redux';
import { RootState } from 'rootReducer';
import { cloudflareUrl } from 'utilities/cloudflareImageResizer';

export const ChannelSmartBanner: FunctionComponent = () => {
  const { nativeUrlSchemeLink } = useNativeEvents();
  const channel = useSelector(
    (state: RootState) => state.channel.channelDetails
  );

  const bannerLink = nativeUrlSchemeLink('mixlr', 'channel', {
    url: window.location.href,
    name: channel?.username,
    theme_color: channel?.themeColor,
    logo_url: cloudflareUrl(channel?.logoKey, {
      width: 100,
      quality: 80,
      baseUrl: process.env.REACT_APP_STORAGE_CDN_URL
    })
  });

  return (
    <Helmet>
      <meta
        name="apple-itunes-app"
        content={`app-id=${process.env.REACT_APP_APPLE_APP_ID}, app-argument=${bannerLink}`}
      />
    </Helmet>
  );
};
